import { useContext } from 'react';

import menuContext from 'pages/layout/components/MenuContext/context';

export default function useMenuContext() {
    return useContext(menuContext);
}
